import React from 'react'

const components = () => <div className="dot-opacity-loader">
<span></span>
<span></span>
<span></span>
</div>

export default components
